import { useQuery } from '@tanstack/react-query'
import { fetchChurnReasons } from '../subscriptions'

export const churnReasonsQueryKey = (slug: string) => [slug, 'stripe', 'churn-reasons'] as const

export const churnReasonsQueryOptions = (slug: string, enabled = true) => ({
  queryKey: churnReasonsQueryKey(slug),
  queryFn: () => fetchChurnReasons({ slug }),
  enabled
})

export const useChurnReasons = (slug: string, enabled = true) =>
  useQuery(churnReasonsQueryOptions(slug, enabled))
